import styled from 'styled-components';

import { breakpoints } from 'utils/mixins';
import { fontSize, space } from 'theme/sizes';
import { toRem } from 'utils/mixins';
import { neutral, danger, success } from 'theme/colors';

export const Wrapper = styled.div`
  position: relative;
  margin: 0;
  margin-bottom: ${space.xs};
  width: 100%;

  .options {
    position: relative;
    padding-bottom: ${space.m};

    label {
      display: block;
      position: absolute;
      left: ${space.xxs};
      top: 0;
      transform: translateY(-90%) scale(0.85);
      padding: 0 ${space.xxs};
      color: ${neutral.neu09};
      margin: 0;
      z-index: 2;
      border-radius: ${space.s};
    }

    .option {
      min-height: ${space.l};
      padding: ${space.xxs} ${space.xs};
      margin: 0;
      margin-right: ${space.xs};
      border: ${toRem(1)} solid ${neutral.neu06};
      outline: none;
      padding-right: ${(props) => props.icon && space.l};
      resize: none;

      &--active {
        border: ${toRem(1)} solid ${success.default};
        background-color: ${`${success.default}44`};
      }
    }
  }

  .input__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    padding: 2px;
    transform: translateY(-50%);
    right: 12px;
    line-height: 1;
    color: ${neutral.neu09};
  }

  .input__error-msg {
    height: ${toRem(32.5)};
    position: absolute;
    bottom: 0;
    margin: 0;
    color: ${danger.default};
    font-size: ${toRem(13)};
  }

  @media ${breakpoints.tablet} {
    width: ${(props) => (props.half ? '48%' : '100%')};
  }
`;
